import { action, observable, set } from "mobx";

class TourExportedTourVideo {
  /**
   * @property {number|null}
   */
  @observable tourId;

  /**
   * @property {string}
   */
  @observable canRequestVideo;

  /**
   * @property {{brandedUrl: string|null, unbrandedUrl: string|null}}
   */
  @observable download = { brandedUrl: null, unbrandedUrl: null };

  /**
   * @property {{connectUrl: string|null, sendToYouTubeUrl: string|null, canDeleteVideo: boolean, viewUrl: string|null, youTubeStatusMsg: string|null}}
   */
  @observable youTube = {
    canDeleteVideo: false,
    connectUrl: null,
    sendToYouTubeUrl: null,
    viewUrl: null,
    youTubeStatusMsg: null,
    title: null,
    description: null,
    privacyStatus: null,
  };

  /**
   * @property {string}
   */
  @observable exportToVideoSpecialInstructions;

  /**
   * @property {number}
   */
  @observable requestStatus;

  /**
   * @property {number}
   */
  @observable requestTime;

  constructor(data) {
    if (data !== undefined) {
      this.setData(data);
    }
  }

  @action
  setData(data) {
    set(this, data);
  }
}

export default TourExportedTourVideo;
